import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 15000,
});

export async function fetchQuestionnaire(slug) {
  const { data } = await api.get(`/api/questionnaires/${slug}`);
  return data;
}

export async function submitScorecard(payload) {
  const { data } = await api.post('/api/submissions', payload);
  return data;
}

export async function fetchResult(token) {
  const { data } = await api.get(`/api/submissions/${token}`);
  return data;
}

export async function fetchAdminSubmissions(questionnaireId) {
  const { data } = await api.get('/api/admin/submissions', {
    params: questionnaireId ? { questionnaireId } : undefined,
  });
  return data.submissions;
}

export async function fetchAdminSubmission(token) {
  const { data } = await api.get(`/api/admin/submissions/${token}`);
  return data;
}

export async function fetchAdminBenchmarks(questionnaireId) {
  const { data } = await api.get('/api/admin/benchmarks', { params: { questionnaireId } });
  return data;
}

export async function fetchAdminQuestionnaires() {
  const { data } = await api.get('/api/admin/questionnaires');
  return data.questionnaires;
}

export async function fetchAdminQuestionnaire(id) {
  const { data } = await api.get(`/api/admin/questionnaires/${id}`);
  return data;
}

export async function createAdminQuestionnaire(payload) {
  const { data } = await api.post('/api/admin/questionnaires', payload);
  return data;
}

export async function updateAdminQuestionnaire(id, payload) {
  const { data } = await api.put(`/api/admin/questionnaires/${id}`, payload);
  return data;
}

export async function setAdminQuestionnaireStatus(id, status) {
  const { data } = await api.patch(`/api/admin/questionnaires/${id}/status`, { status });
  return data;
}

export async function deleteAdminQuestionnaire(id) {
  const { data } = await api.delete(`/api/admin/questionnaires/${id}`);
  return data;
}
